<template>
  <!-- <i class="fa fa-circle-o-notch" aria-hidden="true"></i> -->
  <div class="loading"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></div>
  <!-- <span class="sr-only">Loading...</span> -->
</template>

<script>
export default {
  props: [''],
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
  transform: translateY(1rem);
}
.fa-spin {
  text-align: center;
  font-size: 20px;
  color: #41B883;
  animation-duration: .5s;
}
</style>



// WEBPACK FOOTER //
// Loading.vue?95cb223a